import { apiClient } from './client';
import type { DepartmentSoftware, DepartmentSoftwareWrite } from '@/types/oscar';

/**
 * Typed wrappers over PR-32's `/api/onboarding` department→software endpoints.
 * Reads open to any authenticated Oscar user; mutations are admin-only
 * (enforced server-side).
 */

/** GET /api/onboarding/software-allocations — all allocations (optionally one department). */
export function listDepartmentSoftware(departmentCode?: string, signal?: AbortSignal): Promise<DepartmentSoftware[]> {
  const qs = departmentCode ? `?departmentCode=${encodeURIComponent(departmentCode)}` : '';
  return apiClient.get<DepartmentSoftware[]>(`/api/onboarding/software-allocations${qs}`, signal);
}

/** POST /api/onboarding/departments/:code/software — allocate a pool to a department (admin). */
export function addDepartmentSoftware(code: string, body: DepartmentSoftwareWrite): Promise<DepartmentSoftware> {
  return apiClient.post<DepartmentSoftware>(`/api/onboarding/departments/${encodeURIComponent(code)}/software`, body);
}

/** PATCH /api/onboarding/department-software/:id — toggle mandatory/on-request (admin). */
export function updateDepartmentSoftware(id: number, body: DepartmentSoftwareWrite): Promise<DepartmentSoftware> {
  return apiClient.patch<DepartmentSoftware>(`/api/onboarding/department-software/${id}`, body);
}

/** POST /api/onboarding/department-software/:id/remove — soft delete (admin). */
export function removeDepartmentSoftware(id: number): Promise<{ DepartmentSoftwarePoolId: number; IsDeleted: boolean }> {
  return apiClient.post<{ DepartmentSoftwarePoolId: number; IsDeleted: boolean }>(`/api/onboarding/department-software/${id}/remove`);
}
